export default __webpack_public_path__ + "static/media/90.a4f78fb1.png";